import { Classes } from "./externals";
import * as React from "react";
import "./Layout.scss";
export class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.toggleCollapse = () => {
            this.setState((state) => ({ collapsed: !state.collapsed }));
        };
        this.state = { collapsed: true };
    }
    render() {
        const { Header = () => React.createElement("div", null), Menu = () => React.createElement("div", null), Content = () => React.createElement("div", null), store, logo, } = this.props;
        return (React.createElement("div", { className: "layout-main" },
            React.createElement("div", { className: "layout-vertical" },
                React.createElement("div", { className: "layout-header grey" },
                    React.createElement(Header, { key: "header", logo: logo, collapsed: this.state.collapsed, onChange: this.toggleCollapse, frontInfo: this.props.frontInfo })),
                React.createElement("div", { className: "layout-horizontal layout-lower" },
                    React.createElement("div", { className: `layout-lateral ${Classes.DARK}` },
                        React.createElement(Menu, { key: "menu", collapsed: this.state.collapsed })),
                    React.createElement("div", { className: "layout-content" },
                        React.createElement(Content, { store: store }))))));
    }
}
//# sourceMappingURL=Layout.js.map